import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  TimePicker,
  Button,
  Table,
  Row,
  Col,
  Typography,
} from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Tooltip } from "antd";
import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import Icon from "../../Group.png";
import ConfirmModal from "../../utils/confirmModal";
import { IFetchAllDetails, IPatient } from "../../interfaces/IPatient";
import { IPatientCaseTypesState } from "../../interfaces/ICase";
import utc from "dayjs/plugin/utc";

dayjs.extend(customParseFormat);
dayjs.extend(utc);

const { Title, Text } = Typography;

type ShiftPatientModalProps = {
  isModalVisible: boolean;
  handleCloseModal: any;
  shiftPatientData: any;
  handleOk: () => void;
  handleCancelConfirmationModal: () => void;
  handleShowConfirmPopUp: CallableFunction;
  setIsModalOpen: CallableFunction;
  isModalOpen: boolean;
  isSubmitting: boolean;
  selectedPatient: IFetchAllDetails | null;
  casesType: Array<IPatientCaseTypesState> | null;
  handleUpdateShiftPatient: CallableFunction;
};

type FieldType = {
  shiftTo: string | null;
  shiftDateTime: string | null;
  doa: string | null;
  timeOfAdmission: string | null;
};

const initialValues: FieldType = {
  shiftTo: null,
  shiftDateTime: null,
  doa: null,
  timeOfAdmission: null,
};

const ShiftPatientModal: React.FC<ShiftPatientModalProps> = (props) => {
  const [form] = Form.useForm();
  const [isEditing, setIsEditing] = useState(false);
  const [editingRecord, setEditingRecord] = useState<any>(null);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        if (isEditing) {
          const updatedValues = {
            ...values,
            shiftDateTime: dayjs(values?.shiftDateTime).format(
              "DD-MM-YYYY HH:mm"
            ),
            caseId: props?.selectedPatient?.casesResponse?.id,
            visitId: props?.selectedPatient?.visitInfoResponse?.id,
            oldCaseTypeId: editingRecord?.oldCaseTypeId,
            newCaseTypeId: parseInt(values?.shiftTo?.split("~")[0]),
            oldVisitTypeName: editingRecord?.oldVisitTypeName,
            newVisitTypeName: values?.shiftTo
              ?.split("~")[1]
              ?.toUpperCase()
              ?.includes("EMERGENCY")
              ? "EMERGENCY"
              : values?.shiftTo?.split("~")[1]?.toUpperCase()?.includes("OP") ||
                values?.shiftTo
                  ?.split("~")[1]
                  ?.toUpperCase()
                  ?.includes("DIALYSIS")
              ? "OP"
              : "IP",
          };
          props?.handleUpdateShiftPatient(updatedValues, editingRecord?.id);
          setIsEditing(false);
        } else {
          const updatedValues = {
            ...values,
            shiftDateTime: dayjs(values?.shiftDateTime).format(
              "DD-MM-YYYY HH:mm"
            ),
            caseId: props?.selectedPatient?.casesResponse?.id,
            visitId: props?.selectedPatient?.visitInfoResponse?.id,
            oldCaseTypeId:
              props?.selectedPatient?.casesResponse?.caseTypeMetaDataId,
            newCaseTypeId: parseInt(values?.shiftTo?.split("~")[0]),
            oldVisitTypeName:
              props?.selectedPatient?.visitInfoResponse?.visitType,
            newVisitTypeName: values?.shiftTo
              ?.split("~")[1]
              ?.toUpperCase()
              ?.includes("EMERGENCY")
              ? "EMERGENCY"
              : values?.shiftTo?.split("~")[1]?.toUpperCase()?.includes("OP") ||
                values?.shiftTo
                  ?.split("~")[1]
                  ?.toUpperCase()
                  ?.includes("DIALYSIS")
              ? "OP"
              : "IP",
          };

          props?.handleShowConfirmPopUp(updatedValues);
        }
        // form.resetFields();
        form.setFields([
          { name: "shiftTo", value: null },
          { name: "shiftDateTime", value: null },
        ]);
      })
      .catch((errorInfo) => {});
  };

  const handleCancel = () => {
    props?.handleCloseModal();
    setIsEditing(false);
    setEditingRecord(null);
    form.resetFields();
  };

  const columns = [
    {
      title: "Sr No.",
      dataIndex: "srNo",
      key: "index",
      align: "start" as "start",
    },
    {
      title: "Shift Date",
      dataIndex: "shiftDate",
      key: "shiftDate",
      align: "start" as "start",
    },
    {
      title: "Shift Time",
      dataIndex: "shiftTime",
      key: "shiftTime",
      align: "start" as "start",
    },
    {
      title: "Past Shift",
      dataIndex: "pastShift",
      key: "pastShift",
      align: "start" as "start",
    },
    {
      title: "Current Shift",
      dataIndex: "currentShift",
      key: "currentShift",
      align: "start" as "start",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "start" as "start",
      //   render: (_: any, record: any) => (
      //     <Tooltip title="Edit">
      //       <EditOutlined
      //         style={{
      //           fontSize: '16px',
      //           color: record.srNo > 1 ? '#d9d9d9' : '#1FAF38',
      //           cursor: record.srNo > 1 ? 'not-allowed' : 'pointer',
      //         }}
      //         disabled={record.srNo > 1}
      //       />
      //     </Tooltip>
      //   ),
      render: (_: any, record: any) => (
        <Tooltip
          title={
            isEditing && editingRecord?.key === record.key ? "Cancel" : "Edit"
          }
        >
          {isEditing && editingRecord?.key === record.key ? (
            <Button
              shape="circle"
              icon={<CloseOutlined style={{ color: "#d9534f" }} />}
              onClick={() => {
                setIsEditing(false);
                setEditingRecord(null);
                form.resetFields();
              }}
            />
          ) : (
            <EditOutlined
              style={{
                fontSize: "16px",
                color: record.srNo > 1 ? "#d9d9d9" : "#1FAF38",
                cursor: record.srNo > 1 ? "not-allowed" : "pointer",
              }}
              disabled={record.srNo > 1}
              onClick={() => {
                if (record.srNo <= 1) {
                  setIsEditing(true);
                  setEditingRecord(record);
                  form.setFieldsValue({
                    shiftTo:
                      props.casesType?.find(
                        (caseType) => caseType.name === record.currentShift
                      )?.id +
                      "~" +
                      record.currentShift,
                    shiftDateTime: dayjs(
                      record.shiftDate + " " + record.shiftTime,
                      "DD-MM-YYYY HH:mm"
                    ),
                    doa: record.doa ? dayjs(record.doa, "DD-MM-YYYY") : null,
                    timeOfAdmission: record.doa
                      ? dayjs(record.doa, "HH:mm")
                      : null,
                  });
                }
              }}
            />
          )}
        </Tooltip>
      ),
    },
  ];

  useEffect(() => {
    if (props?.selectedPatient) {
      if (!isEditing) {
        const updatedValues = {
          doa: props?.selectedPatient?.visitInfoResponse?.doa
            ? dayjs(
                props?.selectedPatient?.visitInfoResponse?.doa,
                "DD-MM-YYYY"
              )
            : //   .format("DD-MM-YYYY")
              null,
          timeOfAdmission: props?.selectedPatient?.visitInfoResponse?.doa
            ? dayjs(props?.selectedPatient?.visitInfoResponse?.doa, "HH:mm")
            : null,
        };
        form.setFieldsValue(updatedValues);
      } else {
        const updatedValues = {
          doa: editingRecord?.doa
            ? dayjs(editingRecord?.doa, "DD-MM-YYYY")
            : //   .format("DD-MM-YYYY")
              null,
          timeOfAdmission: editingRecord?.doa
            ? dayjs(editingRecord?.doa, "HH:mm")
            : null,
        };
        form.setFieldsValue(updatedValues);
      }
    }
  }, [
    form,
    props?.selectedPatient,
    isEditing,
    props?.isModalVisible,
    editingRecord?.doa,
  ]);

  const updatedData = props?.shiftPatientData?.map(
    (item: any, index: number) => ({
      key: index + 1,
      srNo: (index + 1).toString(),
      shiftDate: item?.shiftDateTime?.split(" ")[0],
      shiftTime: item?.shiftDateTime?.split(" ")[1],
      pastShift: item?.oldCaseTypeName,
      currentShift: item?.newCaseTypeName,
      doa: item?.doa,
      id: item?.id,
      oldCaseTypeId: item?.oldCaseTypeId,
      oldVisitTypeName: item?.oldVisitTypeName,
    })
  );

  return (
    <>
      <Modal
        title={null}
        visible={props?.isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={866}
        className="shift-details-modal"
        // closable={false}
      >
        <div
          className="modal-header"
          style={{
            backgroundColor: "#E5F3F3",
            padding: "20px 45px",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
            display: "flex",
            alignItems: "center",
            borderBottom: "0.4px solid #A6A6A6",
          }}
        >
          <Title
            level={4}
            style={{ marginBottom: 0, fontSize: "20px", fontWeight: "600" }}
          >
            Shift Details
          </Title>
          <Text className="current-shift" style={{ fontSize: "18px" }}>
            Current Shift:{" "}
            <span
              className="highlighted-text"
              style={{ fontWeight: "600", color: "#008B8B" }}
            >
              {props?.selectedPatient?.casesResponse?.caseTypeMetaDataName}
            </span>
          </Text>
        </div>
        <Form
          form={form}
          initialValues={initialValues}
          layout="vertical"
          className="shift-details-form"
        >
          <Row
            gutter={16}
            style={{
              padding: "10px 30px 0px 30px",
              borderBottom: "0.4px solid #A6A6A6",
            }}
          >
            <Col span={12}>
              <Form.Item
                name="shiftTo"
                label="Shift To"
                rules={[{ required: true, message: "Please select shift!" }]}
                className="shift-modal-form-label"
              >
                <Select placeholder="Select Shift" className="shift-input-box">
                  {/* {
                    props?.casesType?.map((caseType) => (
                        <Select.Option value={caseType?.id + "~" + caseType?.name}>{caseType?.name}</Select.Option>
                    ))
                  } */}
                  {props?.casesType
                    ?.filter(
                      (caseType) =>
                        caseType?.id !==
                        (isEditing
                          ? editingRecord?.oldCaseTypeId
                          : props?.selectedPatient?.casesResponse
                              ?.caseTypeMetaDataId)
                    )
                    ?.map((caseType) => (
                      <Select.Option
                        key={caseType?.id}
                        value={`${caseType?.id}~${caseType?.name}`}
                      >
                        {caseType?.name}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="shiftDateTime"
                label="Shift Date & Time"
                rules={[
                  { required: true, message: "Please select date and time!" },
                ]}
                className="shift-modal-form-label"
              >
                <DatePicker
                  showTime
                  format="DD-MM-YYYY HH:mm"
                  className="shift-input-box"
                  disabledDate={(current) => {
                    const doaValue = form.getFieldValue("doa");
                    return current && current < dayjs(doaValue);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="doa"
                label="DOA / Planned DOA / Date of Visit"
                rules={[{ required: true, message: "Please select date!" }]}
                className="shift-modal-form-label"
              >
                <DatePicker
                  format="DD-MM-YYYY"
                  className="shift-input-box"
                  disabled={true}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="timeOfAdmission"
                label="Time of Admission"
                rules={[{ required: true, message: "Please select time!" }]}
                className="shift-modal-form-label"
              >
                <TimePicker
                  format="HH:mm"
                  className="shift-input-box"
                  disabled={true}
                />
              </Form.Item>
            </Col>
          </Row>
          {/* <Row justify="center" gutter={16} className="form-buttons">
            <Col>
              <Button
                type="default"
                onClick={handleCancel}
                className="cancel-button"
              >
                Cancel
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                onClick={handleOk}
                className="proceed-button"
              >
                Proceed
              </Button>
            </Col>
          </Row> */}
          <Row justify="center" gutter={16} className="form-buttons">
            <Col>
              <Button
                type="default"
                onClick={() => {
                  setIsEditing(false);
                  setEditingRecord(null);
                  form.resetFields();
                  handleCancel();
                }}
                className="cancel-button"
              >
                {isEditing ? "Cancel Edit" : "Cancel"}
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                onClick={() => {
                  //   if (isEditing) {
                  //     form.validateFields().then((values) => {
                  //       const updatedValues = {
                  //         ...values,
                  //         caseId: props.selectedPatient?.casesResponseNew?.id,
                  //         visitId: props.selectedPatient?.visitInfoResponse?.id,
                  //         oldCaseTypeId:
                  //           props.selectedPatient?.casesResponseNew
                  //             ?.caseTypeMetaDataId,
                  //         newCaseTypeId: parseInt(values.shiftTo?.split("~")[0]),
                  //         oldVisitType:
                  //           props.selectedPatient?.visitInfoResponse?.visitType,
                  //         newVisitType: values.shiftTo
                  //           ?.split("~")[1]
                  //           ?.toUpperCase()
                  //           ?.includes("EMERGENCY")
                  //           ? "EMERGENCY"
                  //           : values.shiftTo
                  //               ?.split("~")[1]
                  //               ?.toUpperCase()
                  //               ?.includes("OP") ||
                  //             values.shiftTo
                  //               ?.split("~")[1]
                  //               ?.toUpperCase()
                  //               ?.includes("DIALYSIS")
                  //           ? "OP"
                  //           : "IP",
                  //       };
                  //       setIsEditing(false);
                  //       setEditingRecord(null);
                  //       form.resetFields();
                  //     });
                  //   } else {
                  //     handleOk();
                  //   }

                  handleOk();
                }}
                className="proceed-button"
              >
                {isEditing ? "Update" : "Proceed"}
              </Button>
            </Col>
          </Row>
        </Form>
        <div className="shift-table">
          <Table
            className="shift-details-table"
            rowClassName={(record, index) =>
              index % 2 !== 0 ? "table-row-grey" : "table-row-white"
            }
            columns={columns}
            dataSource={updatedData}
            pagination={false}
          />
        </div>
      </Modal>
      <ConfirmModal
        flagForPatientReg={false}
        isModalOpen={props?.isModalOpen}
        setIsModalOpen={props?.setIsModalOpen}
        handleOk={props?.handleOk}
        handleCancel={props?.handleCancelConfirmationModal}
        isReferralLoading={props?.isSubmitting}
        message={`Do you want to change the shift of the patient`}
        patientFormData={true}
      />
    </>
  );
};

export default ShiftPatientModal;
